import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from 'components/CustomButtons/Button.js';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = (theme) => ({
  root: {
    '& .MuiFormControl-root': {
      margin: theme.spacing(2),
      width: 200,
      marginLeft: '1px',
    },
  },
  rootCircular: {
    flexGrow: 1,
    backgroundColor: '#f1f1f2',
  },
  green: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    width: '100% !important'
  },
  buttonAlign: {
    float: 'right',
  },
});

// preparando refatoração para componente funcional
// const [dateFrom, setDateFrom] = useState(null);
// const handleChangeDateFrom = (dateFrom) => setDateFrom(dateFrom);
// const [dateTo, setDateTo] = useState(null);
// const handleChangeDateTo = (dateTo) => setDateTo(dateTo);
// const [circular, setCircular] = useState(false);
// const handleCircular = () => setCircular(!circular);

class SearchCondominos extends Component {
  state = {
    name: '',
    show: ''
  };

  handleClearInput = () => {
    this.setState({
      name: ''
    });
  };

  handleChange = (event) => {
    const e = event.target.id ? event.target.id : event.target.name;
    const { value } = event.target;

    //console.log(value)

    this.setState({ name: value });
  };

  handleFilterTable = () => {
    const { filterTable } = this.props;
    const { finalField, finalValue, code, porta } = this.state;
    filterTable(finalField, finalValue, code, porta);
    this.handleClearInput();
  };

  handleShowButton = (valor, res, keepPainel) => {
    const { showButtonSearch } = this.props;

    showButtonSearch(valor, res);
  }

  render() {
    const { show, classes, codeAndOperations, portaFilter } = this.props;

    const { dateFrom, dateTo, code, porta } = this.state;

    if (!show) return null;

    return (
      <div className={classes.green}>
        <form className={classes.root} noValidate autoComplete="off">
          <h5>PESQUISAR CONDÔMINOS</h5>

          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <FormControl className={classes.green}>
                <InputLabel htmlFor="codeOrder">Nome, Ala, Bloco ou Apartamento</InputLabel>
                <Input
                  // value={code}
                  onChange={this.handleChange}
                  id="codeOrder"
                  onKeyDown={ (event) => {
                    if (event.key === 'Enter') {
                      // 👇 Get input value
                      this.handleShowButton(this.state.name, true, true)
                    }
                  }}
                />
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              {/* <Button onClick={this.handleFilterTable} color="primary" autoFocus> */}
              <Button onClick={() => this.handleShowButton(this.state.name, true)} color="primary" autoFocus>
                Pesquisar
              </Button>
              <Button onClick={() => this.handleShowButton(null, false)} color="danger" autoFocus>
                FECHAR
              </Button>
            </GridItem>
          </GridContainer>
        </form>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchCondominos);
